"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateFolderModal = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_common_components_1 = require("@desygner/ui-common-components");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const CreateFolderModal_style_1 = require("./CreateFolderModal.style");
const Workspace_context_1 = require("../store/Workspace.context");
const workspace_utils_1 = require("../store/workspace.utils");
const GroupSeachResults_1 = require("./GroupSeachResults");
exports.CreateFolderModal = (0, react_1.memo)(function CreateFolderModal({ isVisible, collection, onCreateFolder, onCloseFolderModal, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const state = (0, Workspace_context_1.useWorkspaceAssets)();
    const [folderName, setFolderName] = (0, react_1.useState)('');
    const [folderRestriction, setFolderRestriction] = (0, react_1.useState)('workspace');
    const [currentSearch, setCurrentSearch] = (0, react_1.useState)('');
    const [selectedGroups, setSelectedGroups] = (0, react_1.useState)([]);
    const parentGroups = (0, react_1.useMemo)(() => {
        const parentFolder = state.navigation[state.navigation.length - 1];
        if (!parentFolder)
            return [];
        return (0, workspace_utils_1.getGroupsFromFolder)(state, parentFolder);
    }, [state]);
    (0, react_1.useEffect)(() => {
        setSelectedGroups(parentGroups);
        if (parentGroups.length) {
            setFolderRestriction('groups');
        }
    }, [parentGroups]);
    const groups = (0, react_1.useMemo)(() => {
        if (!currentSearch)
            return state.groups;
        return state.groups.filter((group) => group.name.toLowerCase().includes(currentSearch.toLowerCase()));
    }, [currentSearch, state.groups]);
    const groupOptions = (0, react_1.useMemo)(() => {
        const options = [
            {
                value: 'workspace',
                label: 'Workspace',
                isSelected: true,
            },
            {
                value: 'groups',
                label: 'Groups',
                isSelected: false,
            },
        ];
        if (parentGroups.length) {
            options[0].isSelected = false;
            options[1].isSelected = true;
            options.shift();
        }
        return options;
    }, [parentGroups]);
    const onSelectedOption = (0, react_1.useCallback)((value) => {
        setFolderRestriction(value);
    }, []);
    const onSearch = (0, react_1.useCallback)((value) => {
        setCurrentSearch(value);
    }, []);
    const closeModal = (0, react_1.useCallback)(() => {
        onCloseFolderModal();
        setFolderName('');
    }, [onCloseFolderModal, setFolderName]);
    const onGroupSelected = (0, react_1.useCallback)((group, checked) => {
        if (checked && !selectedGroups.includes(group)) {
            setSelectedGroups((previous) => [...previous, group]);
        }
        else {
            setSelectedGroups((previous) => previous.filter((g) => g.id !== group.id));
        }
    }, [selectedGroups]);
    const onClickCreateFolder = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const userGroup = folderRestriction === 'workspace' ? undefined : selectedGroups;
        yield onCreateFolder(folderName, userGroup);
        closeModal();
    });
    if (!isVisible)
        return null;
    return ((0, jsx_runtime_1.jsx)(ui_common_components_1.Modal, { children: (0, jsx_runtime_1.jsxs)(CreateFolderModal_style_1.StyledPublishModal, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: "Heading", children: t('tool.library.assets.create_folder') }), (0, jsx_runtime_1.jsxs)(CreateFolderModal_style_1.StyledFolderInput, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: "Body", children: t('tool.library.assets.create_folder_title') }), (0, jsx_runtime_1.jsx)(ui_common_components_1.Input, { size: "Large", name: "create-folder-input", id: "create-folder-input", placeholder: t('tool.library.assets.create_folder_placeholder'), onChange: setFolderName })] }), collection === 'assets' && ((0, jsx_runtime_1.jsxs)(CreateFolderModal_style_1.StyledDropdown, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: "Body", children: "Who should see this" }), (0, jsx_runtime_1.jsx)("div", { style: { width: '100%', position: 'relative' }, children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Select, { options: groupOptions, onChange: onSelectedOption }) })] })), folderRestriction === 'groups' && ((0, jsx_runtime_1.jsxs)(CreateFolderModal_style_1.StyledSearchContainer, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.SearchBox, { id: "GroupInput", placeholder: currentSearch ? currentSearch : 'Search groups', onChange: onSearch }), (0, jsx_runtime_1.jsx)(GroupSeachResults_1.GroupSearchResults, { groups: groups, parentGroups: parentGroups, onSelected: onGroupSelected })] })), (0, jsx_runtime_1.jsx)(CreateFolderModal_style_1.StyledDivider, {}), (0, jsx_runtime_1.jsxs)(CreateFolderModal_style_1.StyledButtonsContainer, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { variant: "ghost", size: "Medium", onClick: closeModal, children: t('general.cancel') }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { variant: "primary", size: "Medium", disabled: !folderName, onClick: onClickCreateFolder, children: t('general.create') }) })] })] }) }));
});
//# sourceMappingURL=CreateFolderModal.js.map